<template>
  <footer class="report-footer">
    <hr class="footer-line" />
    <div class="footer-text">
      All values are determined based off of the inputs into the sizing are an
      estimation of the well performance and not guaranteed of the pump
      performance. This is due to changes in well characteristics, surface
      conditions, potential system degradation, etc. Please reach out to your
      Summit ESP Representative with any questions or concerns.
    </div>
  </footer>
</template>

<style lang="scss">
.report-footer {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 0.1in;
  text-align: center;
  background-color: white;
}

@media screen {
  .report-footer {
    display: none;
  }
}

@media print {
  .report-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding-left: 0.25in;
    padding-right: 0.25in;
    z-index: 0;
    display: block;
  }
}
.footer-line {
  background-color: red;
  border-color: red;
  margin: 0 2% 4px;
}
.footer-text {
  font-size: 0.5rem;
  font-style: italic;
  line-height: 1.1;
  color: #333;
}
</style>
